import authStore from './AuthStore.js';
import globalStore1 from './globalStore1.js';

export const globalStores = {
  authStore,
  globalStore1
};
